import { create } from 'zustand';

export type ToastType = 'error' | 'info' | 'success';

export interface Toast {
  readonly id: string;
  readonly message: string;
  readonly type: ToastType;
}

interface ToastState {
  toasts: Toast[];
  push(message: string, type: ToastType): void;
  dismiss(id: string): void;
}

const DISMISS_AFTER_MS = 3_000;

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push(message, type) {
    const id = crypto.randomUUID();
    // Dedupe: if a toast with the same message + type is already on
    // screen, drop it before pushing the new one. Stops repeated
    // button taps from stacking 4 copies of "Copied" on top of each
    // other.
    set((s) => ({
      toasts: [
        ...s.toasts.filter((t) => !(t.message === message && t.type === type)),
        { id, message, type },
      ],
    }));
    setTimeout(() => {
      set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
    }, DISMISS_AFTER_MS);
  },
  dismiss(id) {
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
  },
}));
